import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import Dropdown from "../Dropdown";
import { PLACEMENT } from "../Dropdown/constants";
import IconMoreHoriz from "../Icon/IconMoreHoriz";
import { CardTitleMenuButton as MenuButton } from "./styled";
import { cardTitleMenuPropTypes } from "./propTypes";

var CardTitleMenu = function CardTitleMenu(props) {
  var triggerTitle = props.triggerTitle,
      restProps = _objectWithoutPropertiesLoose(props, ["triggerTitle"]);

  var rootProps = _objectSpread({
    placement: PLACEMENT['bottom-end']
  }, restProps);

  var buttonProps = {
    iconStart: ___EmotionJSX(IconMoreHoriz, {
      title: triggerTitle
    }),
    minimal: true
  };
  return ___EmotionJSX(Dropdown, rootProps, ___EmotionJSX(MenuButton, buttonProps));
};

CardTitleMenu.displayName = 'CardTitleMenu';
var defaultProps = {
  triggerTitle: 'Card actions'
};
CardTitleMenu.defaultProps = defaultProps;
CardTitleMenu.propTypes = process.env.NODE_ENV !== "production" ? cardTitleMenuPropTypes : {};
export default CardTitleMenu;